// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1ToFT","choiceBoxes":"toolbarselects_choiceBoxes__3Jht9","simpleField":"toolbarselects_simpleField__1RPnT"};